<template>
  <div>
    <document-preview
      id="document-preview"
      :key="documentPreviewHeight"
      :style="{ height: documentPreviewHeight }"
      :document="documentSource.document"></document-preview>
  </div>
</template>

<script setup lang="ts">
import DocumentPreview from '@/components/document-page-template/DocumentPreview.vue'
import { useDocument } from '@/pages/document/single/document'
import { nextTick, ref, watch } from 'vue'

defineOptions({
  name: 'Preview',
})

const { documentSource } = useDocument()

const documentPreviewHeight = ref<string>('100%')
const setDocumentPreviewHeight = () => {
  if (!document) return

  nextTick(() => {
    const documentPreviewElement = document.getElementById('document-preview')!
    if (documentPreviewElement && documentSource.document) {
      console.dir(documentPreviewElement)
      console.dir(documentPreviewElement?.offsetTop)

      if (documentPreviewElement) {
        documentPreviewHeight.value = `calc(100vh - ${
          documentPreviewElement.getBoundingClientRect().top
        }px - 28px)`
        // documentPreviewHeight.value =
        //   documentPreviewElement.clientWidth * 1.41 + 'px'
      }
    }
  })
}
watch(() => documentSource.document, setDocumentPreviewHeight, {
  immediate: true,
})
</script>
